import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/lib/content";
import { Eyebrow, Reveal } from "./Reveal";

export const Faq = () => (
  <section id="faq" className="py-20 sm:py-28 no-print" data-testid="faq-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-10">
      <Reveal className="lg:col-span-4 space-y-4">
        <Eyebrow>Questions</Eyebrow>
        <h2 className="font-serif text-4xl sm:text-5xl text-[#154F49] leading-[1.04]">Frequently asked.</h2>
      </Reveal>
      <Reveal delay={0.1} className="lg:col-span-8">
        <Accordion type="single" collapsible className="border-t border-[#154F49]/15">
          {FAQS.map((f, i) => (
            <AccordionItem key={f.q} value={`faq-${i}`} className="border-b border-[#154F49]/15">
              <AccordionTrigger data-testid={`faq-trigger-${i + 1}`} className="py-6 text-left font-serif text-xl sm:text-2xl text-[#154F49] hover:no-underline hover:text-[#9B742A] focus-visible:ring-2 focus-visible:ring-[#CDA34F] rounded-md">{f.q}</AccordionTrigger>
              <AccordionContent className="text-base text-[#465F57] leading-relaxed pb-6 pr-8">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
